import {Features} from 'constants/plan-access/features';
import {ReactNode} from 'react';
import {NavLink} from 'react-router-dom';
import Tooltip from 'ui/@_components/tooltip';
import styles from './styles.module.scss';
import useHasPlanAccess from 'ui/@hooks/use-has-plan-access';
import LockGradientIcon from 'ui/@_components/kit/icons/lock-gradient.svg?react';
import PagePlanAccessModal from 'ui/@module-components/modals/page-plan-access-modal';
import useDisclosure from 'ui/@hooks/use-disclosure';

interface ElementProps {
  feature: Features | null;
  icon: ReactNode;
  name: string;
  tooltipText: string | null;
  link: string;
  isSidebarOpen: boolean;
}

const ItemLock = ({
  feature,
  icon,
  link,
  name,
  tooltipText,
  isSidebarOpen,
}: ElementProps) => {
  const {hasPlanAccess} = useHasPlanAccess();

  const {isOpen, onClose, onOpen} = useDisclosure();

  const isLocked = !!feature && !hasPlanAccess(feature);

  const renderContent = () => {
    return (
      <>
        <div className={`${styles.iconWrapper} `}>
          <div className={`${styles.icon} ${isLocked ? styles.locked : ''}`}>
            {icon}
          </div>

          {isLocked && <LockGradientIcon className={styles.lockIcon} />}
        </div>

        {isSidebarOpen && (
          <span className={isLocked ? styles.locked : ''}>{name}</span>
        )}
      </>
    );
  };

  const getNavLinkClassName = (isActive: boolean) => {
    if (isActive) {
      return `${styles.activeLink} ${isSidebarOpen ? '' : styles.center}`;
    }

    return `${styles.link} ${isSidebarOpen ? '' : styles.center}`;
  };

  if (isLocked) {
    return (
      <>
        <Tooltip content={tooltipText} place="right" delayShow={100}>
          <div
            onClick={onOpen}
            className={`${styles.link} ${isSidebarOpen ? '' : styles.center}`}
          >
            {renderContent()}
          </div>
        </Tooltip>

        <PagePlanAccessModal
          isOpen={isOpen}
          onHide={onClose}
          feature={feature}
        />
      </>
    );
  }

  return (
    <Tooltip content={tooltipText} place="right" delayShow={100}>
      <NavLink
        className={({isActive}) => getNavLinkClassName(isActive)}
        to={link}
      >
        {renderContent()}
      </NavLink>
    </Tooltip>
  );
};

export default ItemLock;
